export const SITE = {
    name: "IMPRIMA AKI",
    city: "Campinas – SP",
    region: "Campinas e região",
    phoneDisplay: "(19) 99494-5505",
    whatsapp: "5519994945505",
    segments: "Gráfica • Comunicação Visual • Serigrafia • Sublimação",
    instagram: "https://www.instagram.com/imprimaaki",
};

export const DEFAULT_WA_MESSAGE =
    "Olá! Vim pelo site da Imprima Aki e gostaria de solicitar um orçamento.";

export const waLink = (message) =>
    `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message || DEFAULT_WA_MESSAGE)}`;

export const NAV_LINKS = [
    { label: "Início", hash: "#inicio" },
    { label: "Serviços", hash: "#servicos" },
    { label: "Empresas", hash: "#empresas" },
    { label: "Portfólio", hash: "#portfolio" },
    { label: "Sobre", hash: "#sobre" },
    { label: "FAQ", hash: "#faq" },
];

export const QUOTE_PRODUCTS = [
    "Cartão de visita",
    "Panfleto",
    "Banner",
    "Faixa",
    "Placa",
    "Adesivo",
    "Camiseta",
    "Uniforme",
    "Fachada",
    "Envelopamento",
    "Outro",
];
